import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Grid } from "@mui/material";
import { CustomContainer, CustomTable } from '../Tools'
import CreateForm from "./CreateForm";
import { fetchAccounts, deleteAccount } from "../../features/accounts/accountSlice";

const Accounts = () => {
    const { accounts, areas, teachers } = useSelector(state => state.accounts);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchAccounts());
    }, [dispatch])
    const title = 'Cuentas de usuarios';
    const headers = [ { name: 'Usuario', ref: 'usuario' }, { name: 'Nombre', ref: 'nombre' }, { name: 'Área', ref: 'area' } ]
    return(
        <CustomContainer
            content={<CustomTable data={accounts} headers={headers} edit={true} remove={true} showFound={false} />}
            forms={<CreateForm />}
            fnConfirm={deleteAccount}
            title={title}
        >
            <Grid container spacing={2} sx={{ mt: '1em', mb: '1em' }}>
                <Grid item xs={12} sm={12} md={4}>
                    <Alert severity="success">Cuentas creadas: <b>{accounts.length}</b></Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Alert severity="info">Áreas en espera: <b>{areas.length}</b></Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Alert severity="warning">Profesores disponibles: <b>{teachers.length}</b></Alert>
                </Grid>
            </Grid>
        </CustomContainer>
    )
}

export default Accounts;